import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { xlDesktopWidthBreakpoint, smallPhoneWidthBreakpoint, regularPhoneWidthBreakpoint, tabletWidthBreakpoint, desktopWidthBreakpoint, lowestOptimizedWidthBreakpoint, largeDesktopWidthBreakpoint } from '../constants';
import { ApiModelStrategy } from 'src/app/services/rest-api/rest-api';

const MODEL_STRATEGY_CARDS_PER_SWIPER_PAGE = 4;

@Component({
  selector: 'libero-model-strategy-swiper',
  templateUrl: './model-strategy-swiper.component.html',
  styleUrl: './model-strategy-swiper.component.scss',
  standalone: false
})
export class ModelStrategySwiperComponent {
  @Input() public strategies?: ApiModelStrategy[];

  @ViewChild('swiperNextArrow') public swiperNextArrow!: ElementRef;
  @ViewChild('swiperPrevArrow') public swiperPrevArrow!: ElementRef;

  @HostListener('window:resize') public onResize(): void {
    this.cdr.detectChanges();
  }

  public strategiesPerPage = MODEL_STRATEGY_CARDS_PER_SWIPER_PAGE;

  public constructor(
    private cdr: ChangeDetectorRef
  ) { }

  public slidesPerView(slidesLength?: number): number | 'auto' {
    if(!slidesLength) {
      return 'auto';
    }

    if(window.innerWidth < xlDesktopWidthBreakpoint) {
      if(slidesLength === 1) {
        return 1;
      }
      if(window.innerWidth < lowestOptimizedWidthBreakpoint) {
        return 1.1;
      }
      if(window.innerWidth < smallPhoneWidthBreakpoint) {
        return 1.3;
      }
      if(window.innerWidth < regularPhoneWidthBreakpoint) {
        return 1.45;
      }
      if(window.innerWidth < tabletWidthBreakpoint) {
        return 1.7;
      }
      if(window.innerWidth < desktopWidthBreakpoint) {
        return 2.1;
      }
      if(window.innerWidth < largeDesktopWidthBreakpoint) {
        return 2.9;
      }

      return 3.8;
    }

    const FULL_RESOLUTION_OFFSET = 0.11; // to prevent cutting last card border
    return slidesLength > 3 ? (MODEL_STRATEGY_CARDS_PER_SWIPER_PAGE + FULL_RESOLUTION_OFFSET) : slidesLength;
  }
}
